import { http } from '@/core/api/';
const BASE_URL = 'api/pei';

export default {
  GetGrades(payload) {
    return http.get(
      `${BASE_URL}/grades/student?${new URLSearchParams(payload).toString()}`
    );
  },
  GetNecessityInfo(programServiceAreaId, areaId, gradeId, academicYearId) {
    let URL = `${BASE_URL}/getnecessityinfo/${programServiceAreaId}/${areaId}?gradeId=${gradeId ??
      0}&academicYearId=${academicYearId ?? 0}`;

    return http.get(URL);
  },
  GetSkillsInfo(programServiceAreaId, areaId, gradeId, academicYearId) {
    let URL = `${BASE_URL}/getnecessitystrengthinfo/${programServiceAreaId}/${areaId}?gradeId=${gradeId ??
      0}&academicYearId=${academicYearId ?? 0}`;

    return http.get(URL);
  },
  SaveNecessityInfo(dto) {
    return http.post(`${BASE_URL}/savenecessityinfo`, dto);
  },
  GetProcedureInfo(programServiceAreaId) {
    let URL = `${BASE_URL}/procedures/${programServiceAreaId}`;
    return http.get(URL);
  },
  SaveProcedureInfo(dto) {
    return http.post(`${BASE_URL}/procedures/save`, dto);
  },
  SaveSkillsInfo(dto) {
    return http.post(`${BASE_URL}/savenecessityinfoAndStrength`, dto);
  },
  GetGoalsInfo(programServiceAreaId) {
    return http.get(
      `${BASE_URL}/GetProgramServiceGoals/${programServiceAreaId}`
    );
  },
  GetAdequacies() {
    return http.get(`${BASE_URL}/GetPeiCodes`);
  },
  GetGoalCatalogues() {
    return http.get(`${BASE_URL}/getpeigoaloptions`);
  },
  GetStrengthInfo(programServiceAreaId, areaId, gradeId, academicYearId) {
    let URL = `${BASE_URL}/getstrengthinfo/${programServiceAreaId}/${areaId}?gradeId=${gradeId ??
      0}&academicYearId=${academicYearId ?? 0}`;

    return http.get(URL);
  },
  SaveStrengthsInfo(dto) {
    return http.post(`${BASE_URL}/savestrengthinfo`, dto);
  },
  GetSubAreas(programServiceAreaId, areaId) {
    return http.get(`${BASE_URL}/subareas/${programServiceAreaId}/${areaId}`);
  },
  SaveSubAreas(dto) {
    return http.post(`${BASE_URL}/subareas/save`, dto);
  },
};
